import React from 'react'
import * as Sentry from '@sentry/react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import './sentry'

/* aws */
import { Amplify } from 'aws-amplify'
import config from './config'

import { AuthProvider } from './context/AuthContext'
import { ChatProvider } from './context/ChatContext'
import { SnackbarProvider } from 'notistack'

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID
  },
  Storage: {
    region: config.s3.REGION,
    bucket: config.s3.BUCKET,
    identityPoolId: config.cognito.IDENTITY_POOL_ID
  },
  API: {
    endpoints: [
      {
        name: 'freebee',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      }
    ]
  }
})

const root = createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <BrowserRouter>
    <SnackbarProvider maxSnack={99}>
      <AuthProvider>
        <ChatProvider>
          <Sentry.ErrorBoundary fallback={<div>Error</div>}>
            <App />
          </Sentry.ErrorBoundary>
        </ChatProvider>
      </AuthProvider>
    </SnackbarProvider>
  </BrowserRouter>
)
